export default "__VITE_ASSET__cQ_Xg_tr__"